import React from 'react'
import '../assets/blog.css';
import Navbar from '../components/Navbar.js'
import Footer from '../components/Footer.js'
import { Helmet } from 'react-helmet-async'

function Blog() {
  return (
    <div>
         <Helmet>
          <title>LexiTrove's Blog | Employment Law Intelligence Platform </title>
          <meta name='description' content='Your legal intelligence hub. Browse our collection of employment law articles,and regulatory insights written for modern practitioners'/>
          <link rel='canonical' href='https://www.lexitrove.com/blog'/>
          <meta property="og:site_name" content="LexiTrove" />
          <meta property="og:type" content="website" />
          <meta property="og:title" content="LexiTrove's Blog | Employment Law Intelligence Platform"/>
          <meta property="og:url" content='https://www.lexitrove.com/blog' />
          <meta property="og:description" content= "Your legal intelligence hub. Browse our collection of employment law articles,and regulatory insights written for modern practitioners"/>
        </Helmet>
        <div className='home'>
        <Navbar/>
        <div className='blogcard'>
        <h3><a href='/blog/Beyond-the-April-Horizon-What-ERA-2025-Demands-of-Employment-Practitioners-Right-Now'>Beyond the April Horizon: What ERA 2025 Demands of Employment Practitioners Right Now</a></h3>
        <hr/>
        <p>9 Min Read | By Rohit Kumar</p>
        <p><a href='/blog/Beyond-the-April-Horizon-What-ERA-2025-Demands-of-Employment-Practitioners-Right-Now'>If you feel like you've barely caught your breath after the April 2026 rollout of Statutory Sick Pay reforms and Day 1 paternity rights, you're not alone. Welcome to July 2026.The Employment Rights Act 2025 isn't a single legal change. It's a sequence of legal changes arriving on different dates</a></p>
        <button className='cta-button'><a href="/blog/Beyond-the-April-Horizon-What-ERA-2025-Demands-of-Employment-Practitioners-Right-Now">Read More</a></button>
        </div>
        </div>
        <Footer/>
    </div>
  )
}

export default Blog